// tslint:disable:no-import-side-effect
import "./nautilus/compatibility/polyfill/polyfill"; // Register missing methods for old browsers
import "./extend/stringextend";
import "./nautilus/knockout/ko-binding-handlers";
import "./nautilus/core/debugging/debugging";
import "./nautilus/devexpress/html-db-control";
import "./nautilus/devexpress/validation/validation-functions";
// tslint:enable:no-import-side-effect
import { KnockoutHelper } from "./nautilus/knockout/knockout-helper";
import { LoginViewModel } from "./nautilus/core/login";
import { DialogResultVm } from "./nautilus/checkresultdialog/dialogresultvm";
import { ErrorHelper } from "./nautilus/core/error";
import { ConnectionInformationVm } from "./nautilus/version/connection-information-vm";
import { ActiveModuleHelper } from "./nautilus/core/module/active-module-helper";
import { UrlHelper } from "./nautilus/core/html/url-helper";
import { ServiceProvider } from "./nautilus/core/provider/service-provider";
import { DebuggingVm } from "./nautilus/core/debugging/debugging-vm";
import { E2EHelper } from "./nautilus/core/e2e-helper";
import { CheckResultData, ResultLevel } from "./nautilus/checkresultdialog/checkresultdata";
import { ShowInfoLabel } from "./nautilus/format/show-info-label";
import { BrowserDetectionHelper } from "./nautilus/compatibility/browser-detection-helper";
import { ChangeMarketerHeaderVm } from "./nautilus/header/change-marketer-header-vm";
import { SharedLang } from "./Generated/Shared-lang";
import { HeaderFavIconAnimationVm } from "./nautilus/header/header-fav-icon-animation-vm";
import { Logger } from "./nautilus/logger/logger";

E2EHelper.initialize();

let startupCheck = () => {
	let checkResultData = new CheckResultData();

	// check version number
	let clientDbDiffKey = "client_db_different_ok";
	if (UrlHelper.getBool("data-db-client-version-distinct") && sessionStorage.getItem(clientDbDiffKey) == null) {
		sessionStorage.setItem(clientDbDiffKey, "true");
		let clientVersion = UrlHelper.getData("data-client-version");
		let dbVersion = UrlHelper.getData("data-db-version");
		checkResultData.addError(`Die Version des Clients (${clientVersion}) unterscheidet sich von der Version der Datenbank (${dbVersion})`, "Versionsunterschied");
	}

	// check time offset
	let dbTimeDiffKey = "db_time_diff_ok";
	if (UrlHelper.getBool("db-has-time-diff") && sessionStorage.getItem(dbTimeDiffKey) == null) {
		sessionStorage.setItem(dbTimeDiffKey, "true");
		let dbTimeDiff = UrlHelper.getData("db-time-diff-formatted");
		checkResultData.addError(`Die Anwendung verwendet ein abweichendes Datum. Abweichung: \r\n${dbTimeDiff}`, "Zeitunterschied");
	}

	// check active adserver
	let adserverActiveKey = "adserver_active_warning";
	let adserverActiveWarning = UrlHelper.getData("adserver-active-warning");
	if (adserverActiveWarning && adserverActiveWarning !== sessionStorage.getItem(adserverActiveKey)) {
		sessionStorage.setItem(adserverActiveKey, adserverActiveWarning);
		checkResultData.addWarning(adserverActiveWarning, "AdServer");
	}

	let adElement = document.querySelector(".banner_ad");
	let adblockKey = "adblocker_warning";
	if (sessionStorage.getItem(adblockKey) == null
		&& (!adElement || adElement.innerHTML.length === 0 || adElement.clientHeight === 0 || window.getComputedStyle(adElement).display === "none")) {
		sessionStorage.setItem(adblockKey, "true");
		checkResultData.addWarning("Bitte deaktivieren sie ihren Ad-Blocker, andernfalls funktionieren nicht alle Funktionen.", "Ad-Blocker erkannt");
	}

	// show messages if there
	if (checkResultData.highestLevel > ResultLevel.Ok) {
		DialogResultVm.showDialog(checkResultData);
	}
};

$(document).ready(async () => {
	// initialize cache
	ServiceProvider.cache.initializeCache(UrlHelper.getCacheId());
	try {
		await Promise.all([
			SharedLang.intializeAsync()
		]);
	} catch (err) {
		Logger.error(err);
	}

	ErrorHelper.handleError();
	ActiveModuleHelper.activateKeepAlive();

	if ($("#login-dialog").length > 0) {
		KnockoutHelper.applyBindingsIfElementExists(LoginViewModel.getInstance(), document.getElementById("login-dialog"));
	}

	KnockoutHelper.applyBindingsIfElementExists(DialogResultVm.getInstance(),
		document.getElementById("nautilus-shared-checkresultdialog"));

	KnockoutHelper.applyBindingsIfElementExists(ConnectionInformationVm.getInstance(),
		document.getElementById("app-info"));

	KnockoutHelper.applyBindingsIfElementExists(ConnectionInformationVm.getInstance(),
		document.getElementById("user-info"));

	KnockoutHelper.resolveAndApplyBindingsIfElementExists(DebuggingVm.getInstance, document.getElementById("app-debug"));

	$("#app-info").mouseenter(() => {
		ConnectionInformationVm.getInstance().updateAsync();
	});

	$(".nautilus-sidebar > a.nav-link:first-child").click(() => {
		$("body.nautilus").toggleClass("nautilus-sidebar-collapsed");
		$(".nautilus-sidebar").find("a.nav-link:first-child .fa").toggleClass("fa-caret-left").toggleClass("fa-caret-right");
	});

	ChangeMarketerHeaderVm.initialize();
	HeaderFavIconAnimationVm.initialize();
	ShowInfoLabel.create();
	startupCheck();
});